import { TextField, styled } from "@mui/material";
import theme from "../../../theme";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTextField = styled(TextField)({ '&.MuiTextField-root .Mui-focused fieldset': {
        // width: '500px'
        borderColor: theme.palette.rnSteel.steel700
    } });
export var TextBoxComponent = function (_a) {
    var id = _a.id, value = _a.value, placeholder = _a.placeholder;
    return /*#__PURE__*/ _jsx(StyledTextField, { id: id, value: value, placeholder: placeholder });
};
